<template>
  <el-image
    :src="real"
    fit="cover"
    :style="`width:${realWidth};height:${realHeight};`"
    :preview-src-list="srcList"
  >
  <!-- <template>
  <el-image
    :src="`${realSrc}`"
    fit="cover"
    :style="`width:${realWidth};height:${realHeight};`"
    :preview-src-list="srcList"
  > -->
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
import { getappends } from "@/api/system/dict/data";

export default {
  name: "ImagePreview",
  props: {
    src: {
      type: String,
      default: "",
    },
    width: {
      type: [Number, String],
      default: "",
    },
    height: {
      type: [Number, String],
      default: "",
    },
  },

  data() {
    return {
      srcList: [],
      real:""
    };
  },
  computed: {
   
    
    realWidth() {
      return typeof this.width == "string" ? this.width : `${this.width}px`;
    },
    realHeight() {
      return typeof this.height == "string" ? this.height : `${this.height}px`;
    },
  },
  watch: {
      src: {
        handler ( val ) {
          if (val) {
            this.fileList = [];
            this.realSrc();
            this.realSrcList()
          } else {
            // this.fileList = [];
            // return [];
          }
        },
        deep: true,
        immediate: true
      }
    },
  created() {
    // this.realSrc();
    // this.realSrcList()
  
  },
  methods: {

    // 通过附件的ID，获取附件的详细信息
     getapp(item) {
       
      var that =this;
      return new Promise((resolve, reject) => {
           
            getappends(item).then((res) => {
           that.srcList.push(res.data.url);
      });
            resolve()
 
    })
    },
    realSrc() {
      if (!this.src) {
        console.log("返回的是空");
        
        return;
      }
      // let real_src =              this.src.split(",")[0] ;
      // return real_src;
      // return "http://127.0.0.1:9300/statics/baseinformation/school/top1_20240808152337A017.png";

      if (this.src.split(",")[0].length&&this.src.split(",")[0].length<40) {
        
        getappends(this.src.split(",")[0]).then((res) => {
          let real_src = res.data.url;
          console.log(real_src,"真实的图片");

          return this.real=  real_src;
        });

      }
    },

    realSrcList() {
      var that =this;
      if (!this.src) {
        return;
      }
      var real_src_list = this.src.split(",") || [];
      that. srcList =[],// ["http://127.0.0.1:9300/statics/baseinformation/school/top1_20240808152337A017.png","http://127.0.0.1:9300/statics/baseinformation/school/top1_20240808152337A017.png"];
      //  real_src_list.forEach(async (item) => {
      // await  this.getapp(item);
      // });

      // // this.$nextTick(() => {
      //   return this.srcList;
      // // });
      
// Promise.all(

// if ( Array.isArray(real_src_list) ) {

// }
      console.log(real_src_list,"需要遍历的对象");
      
  real_src_list.forEach(async (item)=> {
    if (item.length&&item.length>17) {
      return;
    }
    console.log(item,"打印出来附件ID");
    
        return new Promise(async (resolve, reject) => {
          if (item.length&&item.length<17) {
            
            await that.getapp(item);
          }
         
            resolve(
         
            )
 
        })
    })

 
// ).then(() => {
    
//     return that.srcList;
// })

    },
  },
};
</script>

<style lang="scss" scoped>
.el-image {
  border-radius: 5px;
  background-color: #ebeef5;
  box-shadow: 0 0 5px 1px #ccc;
  ::v-deep .el-image__inner {
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      transform: scale(1.2);
    }
  }
  ::v-deep .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 30px;
  }
}
</style>
